import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import gsap from "gsap";

export const otherLogosBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.logos-section-js', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const track = section.querySelector('.other-logos__slider-wrapper');
    const ticker = section.querySelector('.other-logos__slider');

    const original = track.innerHTML;
    let tickerAnim = null;

    const createTruckAnim = () => {
        if(tickerAnim !== null){
            tickerAnim.kill();
            tickerAnim = null;
        }
        track.innerHTML = original + original + original;

        const singleSetWidth = track.scrollWidth / 3;

        gsap.set(track, {
            x: -singleSetWidth / 2,
        });

        tickerAnim = gsap.to(track, {
            x: `-=${singleSetWidth}`,
            duration: 30,
            ease: "none",
            repeat: -1,
            paused: true
        });

        // пауза при ховері
        ticker.addEventListener('mouseenter', () => tickerAnim.pause());
        ticker.addEventListener('mouseleave', () => {
            if(isInView) tickerAnim.resume();
        });
    }

    createTruckAnim();

    const rebuildFunc = () => {
        createTruckAnim();
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);

    // ---- IntersectionObserver ----
    let isInView = false;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                isInView = true;
                tickerAnim && tickerAnim.resume();
            } else {
                isInView = false;
                tickerAnim && tickerAnim.pause();
            }
        });
    }, {
        threshold: 0.2
    });

    observer.observe(section);
}